import styled, { css } from 'styled-components'
import { BP } from 'resources/constants'

export const containerCss = css`
  padding: 0 15px;
  margin: 0 auto;

  @media (min-width: ${BP.sm.min}) {
    max-width: ${BP.sm.max};
  }

  @media (min-width: ${BP.md.min}) {
    max-width: ${BP.md.max};
  }

  @media (min-width: ${BP.lg.min}) {
    max-width: ${BP.lg.max};
  }
`

export const Container = styled.div`
  ${containerCss}
`
